import AddToCartAction from '../AddToCartAction';
import * as style from './PriceAndBuy.module.css';
import type { DetailedProduct } from './ProductDetailsPage';

export default function PriceAndBuy({ product }: { product: DetailedProduct }) {
    return (
        <div className={style.priceAndBuy}>
            <div className={style.priceAndVolume}>
                <ValueSpan value={product.price} className={style.price} />
                <span className={style.volumeAndCostPerUnit}>
                    <ValueSpan value={product.volume} className={style.amount} /> <ValueSpan value={product.litrePrice} />
                </span>
            </div>
            <AddToCartAction code={product.code} buyable={product.buyable} maxQuantity={product.maxQuantity} />
        </div>
    );
}

function ValueSpan({ value, className }: { value: { readableValue?: string; formattedValue?: string } | undefined; className?: string }) {
    if (!value?.formattedValue) return null;

    return (
        <span className={className} aria-label={value.readableValue}>
            {value.formattedValue}
        </span>
    );
}
